import PropTypes from "prop-types"

/**
 * PropTypes for the OCPI Communications SidebarSection component.
 *
 * @property {Object|null} selectedEntry - Currently selected communication log row (null if no selection)
 * @property {Object} filters - Current filter state
 * @property {Function} onFilterChange - Filter change dispatcher
 * @property {number} visibleCount - Number of entries after filtering
 * @property {Function} onRetry - Resends the selected entry (only called when it is resendable)
 * @property {boolean} isRetrying - Whether the resend request for the selected entry is in flight
 */
export const ocpiCommunicationsSidebarSectionPropTypes = {
	selectedEntry: PropTypes.object,
	filters: PropTypes.object.isRequired,
	onFilterChange: PropTypes.func.isRequired,
	visibleCount: PropTypes.number.isRequired,
	onRetry: PropTypes.func,
	isRetrying: PropTypes.bool,
}

/**
 * PropTypes for OcpiCommunications view.
 * No external props are expected; kept for consistency across view definitions.
 */
export const ocpiCommunicationsViewPropTypes = {}
